// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"73":"b1a0ba97","272":"0b3df5d3","412":"b00edf5b","655":"b00edf5b","804":"f716ab75"}[chunkId] + ".chunk.css";
};